import { AttrField, BelongsToField, BooleanField, OrmModel, StringField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'
import type { AvatarFile } from '@/data/models/domain/Contact'
import Country from '@/data/models/domain/Country'
import type { TmCountryCode } from '@/services/types'

@OrmModel(modelNames.RECIPIENT_CONTACT)
export default class RecipientContactContact<TPhone extends string | null = string | null> extends BaseModel {
  @StringField()
  public id: string

  @AttrField()
  public firstName: string | null

  @AttrField()
  public lastName: string | null

  @AttrField()
  public countryId: TmCountryCode | null

  @BelongsToField(Country, 'countryId')
  public country: Country | null

  @StringField(null)
  public phone: TPhone

  @StringField(null)
  public email: string | null

  @AttrField()
  public avatar: AvatarFile | null

  @BooleanField()
  public isDeleted: boolean

  @BooleanField()
  public isBlocked: boolean

  public get fullName() {
    return [this.firstName, this.lastName]
      .filter((t) => t !== null)
      .join(' ')
      .trim()
  }
}
